import './Navbar.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

import jd_logo from '../icons/monocromatic-icons-01.png';
import menu_icon from '../icons/monocromatic-icons-02.png';
import close_icon from '../icons/monocromatic-icons-03.png';


function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if(window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <img src={jd_logo} className="navbar-logo-img" />
          </Link>
          <div className='menu-icon' onClick={handleClick}>
            <img src={click ? close_icon : menu_icon} className={click ? "navbar-menu-open" : 'navbar-menu-close'} />
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className='nav-item'>
              <Link to='/contact' className='nav-links' onClick={closeMobileMenu}>Contact</Link>
            </li>
            <li className='nav-item'>
              <Link to='/education' className='nav-links' onClick={closeMobileMenu}>Education</Link>
            </li>
            <li className='nav-item'>
              <Link to='/' className='nav-links' onClick={closeMobileMenu}>Home</Link>
            </li>
            <li className='nav-item'>
              <Link to='/interests' className='nav-links' onClick={closeMobileMenu}>Interests</Link>
            </li>
            <li className='nav-item'>
              <Link to='/projects' className='nav-links' onClick={closeMobileMenu}>Projects</Link>
            </li>
            {/*
            <li>
              <Link to='/sign-up' className='nav-links-mobile' onClick={closeMobileMenu}>Sign Up</Link>
            </li>
            */}
          </ul>
          {/*{button && <Button buttonStyle='btn-outline'>Sign Up</Button>}*/}
        </div>
      </nav>
    </>
  );                      
}
    
export default Navbar;
